import { ButtonList, DropdownButton } from '@dixa/lib-shared-habla';
import { SearchFilters } from 'lib-search-types';
import { ampli } from 'lib-shared-tracking';
import { User } from 'lib-shared-types-api';

import { createSearchUrlParams } from 'app/views/layout/views/search/utils';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useAppNavigate } from 'utils/url/useAppNavigate';

type ConversationsActionProps = {
  user: User;
};

export const ConversationsAction = ({
  user,
}: ConversationsActionProps): JSX.Element | null => {
  const navigate = useAppNavigate();
  const flags = useFeatureFlag(['agent-activity-log', 'contact-activity-log']);
  if (
    !(flags.agentActivityLog && user.type === 'member') &&
    !(flags.contactActivityLog && user.type === 'contact')
  ) {
    return null;
  }

  const navigateToConversations = (filters: SearchFilters<'conversations'>) => {
    navigate({
      path: '/search/:scope',
      params: createSearchUrlParams({
        scope: 'conversations',
        filters,
      }),
    });
    ampli.contactsCardSeeAllAssignedConversationsClicked();
  };

  return (
    <DropdownButton
      icon="conversations"
      dropdown={
        <ButtonList>
          <ButtonList.Item
            onClick={() => {
              navigateToConversations({
                strategy: 'all',
                filters: [
                  {
                    field: 'agent_id',
                    operator: 'is_one',
                    values: [{ value: user.id }],
                  },
                ],
              });
            }}
          >
            All assigned conversations
          </ButtonList.Item>
          <ButtonList.Item
            onClick={() => {
              navigateToConversations({
                strategy: 'all',
                filters: [
                  {
                    field: 'requested_by',
                    operator: 'is_one',
                    values: [{ value: user.id }],
                  },
                ],
              });
            }}
          >
            All created conversations
          </ButtonList.Item>
        </ButtonList>
      }
    >
      Conversations
    </DropdownButton>
  );
};
